import classNames from 'classnames';
import {
    useRef, useState, useEffect, useCallback
} from 'react';
import { getIncrementalArray } from 'helpers/array';
import { Button } from 'palette/Button';
import { useTranslation } from '@common/Hooks/useTranslation';
import '../styles/Dropdown.scss';

function Dropdown({
    onChange,
    currentPage,
    pageCount,
    customStyle
}) {
    const translate = useTranslation();
    const dropdownElement = useRef();
    const [isVisible, setIsVisible] = useState(false);
    const list = getIncrementalArray(pageCount);
    const dropdownClass = classNames({
        dropdown: true,
        'dropdown--open': isVisible
    });

    const handleChange = (event) => {
        const page = parseInt(event.currentTarget.value, 10);
        onChange(page);
    };

    const handleToggleButtonClick = () => {
        if (!isVisible) {
            setTimeout(() => setIsVisible(true), 100);
        }
    };

    const closeDropdown = useCallback(() => {
        setIsVisible(false);
    }, []);

    useEffect(() => {
        if (!customStyle) { return; }

        if (isVisible) {
            document.addEventListener('click', closeDropdown);
        } else {
            document.removeEventListener('click', closeDropdown);
        }

        // eslint-disable-next-line consistent-return
        return () => document.removeEventListener('click', closeDropdown);
    }, [closeDropdown, customStyle, isVisible]);

    useEffect(() => {
        if (customStyle) {
            return;
        }

        const scrollOffset = dropdownElement.previousSibling.offsetHeight * currentPage;

        // Hack for scroll update
        dropdownElement.style.cssText = 'opacity: 0; display: block; visibility: hidden;';
        dropdownElement.scrollTop = scrollOffset;
        dropdownElement.style.cssText = '';
    }, [currentPage, customStyle]);

    return (
        <div className={dropdownClass}>
            <Button
                iconName="palette_chevron_down"
                label={`${translate('listing.paging.page.label')} ${currentPage}/${pageCount}`}
                theme="secondary"
                onClick={handleToggleButtonClick}
            />
            {customStyle && (
                <div
                    ref={dropdownElement}
                    className="dropdown__list"
                >
                    <ul>
                        {list.map(index => (
                            /* eslint-disable-next-line jsx-a11y/click-events-have-key-events,
                            jsx-a11y/no-noninteractive-element-interactions */
                            <li
                                key={index}
                                className={`${index === currentPage ? 'selected' : ''}`}
                                data-page={index}
                                onClick={() => { onChange(index); }}
                            >
                                {index}
                            </li>
                        ))}
                    </ul>
                </div>
            ) }
            <div className="dropdown__select">
                <select
                    aria-label="Pagination Dropdown"
                    value={currentPage}
                    onChange={handleChange}
                >
                    {list.map(index => (
                        <option
                            key={index}
                            value={index}
                        >
                            {index}
                        </option>
                    ))}
                </select>
            </div>
        </div>
    );
}

export default Dropdown;
